import {ModuleWithProviders} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {NodeInformatiomComponent} from './header/node-informatiom/node-informatiom.component';
import {SizerType} from './models/generic.model';

export const AppRoutes: Routes = [
  {
    path: 'opportunities',
    loadChildren: () => import('./opportunities-container/opportunities.module').then(m => m.OpportunitiesModule),
    data: {
      viewName: 'opportunities',
      sizerType: SizerType.Default
    }
  },
  {
    path: 'site',
    loadChildren: () => import('./opportunity-details/oppo-details.module').then(m => m.OppoDetailsModule),
    data: {
      viewName: 'opportunity-details'
    }
  },
  {
    path: 'nodeInformation',
    component: NodeInformatiomComponent,
    data: {
      viewName: 'nodeInformation'
    }
  },
  {
    path: 'analytics',
    loadChildren: () => import('./analytics/analytics.module').then(m => m.AnalyticsModule),
    data: {
      viewName: 'analytics'
    }
  },
  {
    path: 'all-opportunities',
    loadChildren: () => import('./commercial-sizer/commercial-sizer.module').then(m => m.CommercialSizerModule),
    data: {
      viewName: 'commercial-sizer',
      sizerType: SizerType.Commercial
    }

  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: '/opportunities'
  }    // <-- Any unknow path / route / view name
];

export const RouterConfigModule: ModuleWithProviders<any> = RouterModule.forRoot(AppRoutes, {
    // enableTracing: (!environment.production), // <-- debugging purposes only
    useHash: true
});
